import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ImageCarousel from './ImageCarousel';
import '../styles/CarCard.css';

const CarCard = ({ car, featured = false, currentSearch = '' }) => {
  const [isHovered, setIsHovered] = useState(false);
  const formatPrice = (price) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
    }).format(price);
  };

  const formatKilometrage = (km) => {
    return new Intl.NumberFormat('fr-FR').format(km) + ' km';
  };



  const getEnergyIcon = (energie) => {
    switch (energie.toLowerCase()) {
      case 'essence':
        return '⛽';
      case 'diesel':
        return '🛢️';
      case 'électrique':
        return '⚡';
      case 'hybride':
        return '⚡⛽';
      case 'hybride rechargeable':
        return '🔌';
      default:
        return '⛽';
    }
  };

  const getEnergyLabel = (energie) => {
    if (energie.toLowerCase() === 'hybride rechargeable') {
      return 'Hyb. Rechargea..';
    }
    return energie;
  };

  const getEnergyClass = (energie) => {
    switch (energie.toLowerCase()) {
      case 'essence':
        return 'fuel-essence';
      case 'diesel':
        return 'fuel-diesel';
      case 'électrique':
        return 'fuel-electric';
      case 'hybride':
        return 'fuel-hybrid';
      case 'hybride rechargeable':
        return 'fuel-hybrid-rechargeable';
      default:
        return 'fuel-default';
    }
  };

  const getCritAirColor = (critAir) => {
    switch (critAir) {
      case 0: return '#00b04f'; // Vert
      case 1: return '#68d391'; // Vert clair
      case 2: return '#ffd700'; // Jaune
      case 3: return '#ff8c00'; // Orange
      case 4: return '#dc2626'; // Rouge
      case 5: return '#7c2d12'; // Marron
      default: return '#6b7280'; // Gris
    }
  };

  return (
    <div
      className={`car-card ${!car.disponible ? 'sold' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="car-header">
        <span className="car-vo">N° {car.vo}</span>
        <div style={{ display: 'flex', gap: '8px' }}>
          <span className={`critair-badge critair-${car.critAir}`} style={{ backgroundColor: getCritAirColor(car.critAir) }}>
            Crit'Air {car.critAir}
          </span>
        </div>
      </div>

      <div className="car-image">
        <ImageCarousel
          images={car.images}
          alt={`${car.marque} ${car.modele}`}
          isHovered={isHovered}
        />
        {!car.disponible && <div className="sold-overlay">VENDU</div>}
      </div>

      <div className="car-info">
        <h3 className="car-title">{car.modele}</h3>
        <div className="car-brand">
          <span className="brand-value">{car.marque}</span>
        </div>
        <div className="car-specs">
          <div className="spec-row hide-mobile">
            <span className="car-year">📅 {car.annee}</span>
            <span className={`car-fuel ${getEnergyClass(car.energie)}`}>
              {getEnergyIcon(car.energie)} {getEnergyLabel(car.energie)}
            </span>
          </div>

          <div className="spec-row hide-mobile">
            <span className="car-km">🛣️ {formatKilometrage(car.kilometrage)}</span>
            <span className="car-power">⚡ {car.puissanceFiscale} CV</span>
          </div>
        </div>

        <div className="car-footer">
          <div className="price-info">
            <div className="car-price">{formatPrice(car.prix)}</div>
            <div className="price-details">
              TTC hors forfait immat. et carte grise
            </div>
          </div>
          <Link
            to={{
              pathname: `/voiture/${car.id}`,
              search: currentSearch || ''
            }}
            state={{ from: `/stock${currentSearch || ''}` }}
            className={`btn ${!car.disponible ? 'btn-disabled' : 'btn-primary'}`}
          >
            {car.disponible ? 'Voir détails' : 'Indisponible'}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CarCard;
